<template>
    <div>
        <v-dialog width="600" v-model="showDialog" persistent>
            <v-card >
                <v-card-title class="primary_2 white--text">
                    Edit Product Details
                </v-card-title>
                <v-card-text class="pt-6">
                    <v-form ref="productForm" v-model="valid">
                        <!-- Basic Information Section -->
                        <div class="text-h6 mb-4">Basic Information</div>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="formData.name"
                                    label="Product Name*"
                                    :rules="$rules.REQUIRED_FIELD"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="formData.title"
                                    label="Product Title*"
                                    :rules="$rules.REQUIRED_FIELD"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="6">
                                <v-select
                                    v-model="formData.product_type_ids"
                                    :items="productTypes"
                                    item-text="loan_type"
                                    item-value="id"
                                    label="Product Types*"
                                    :rules="requiredArrayRule"
                                    multiple
                                    chips
                                    small-chips
                                    deletable-chips
                                    outlined
                                    dense
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="formData.rank"
                                    label="Rank"
                                    :rules="rankRules"
                                    type="number"
                                    min="1"
                                    hint="1 = shown first to users"
                                    persistent-hint
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="formData.web_url"
                                    label="Website URL*"
                                    :rules="$rules.REQUIRED_FIELD"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="formData.utm_link"
                                    label="UTM Link*"
                                    :rules="$rules.REQUIRED_FIELD"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-divider class="my-4"></v-divider>

                        <!-- Loan Details Section -->
                        <div class="text-h6 mb-4">Loan Details</div>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="formData.interest_rate"
                                    label="Interest Rate*"
                                    :rules="$rules.REQUIRED_FIELD"
                                    placeholder="e.g., 10.5% - 15%"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="formData.tenure"
                                    label="Tenure*"
                                    :rules="$rules.REQUIRED_FIELD"
                                    placeholder="e.g., 12-60 months"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="formData.loan_upto"
                                    label="Loan Amount (Up to)*"
                                    :rules="$rules.REQUIRED_FIELD"
                                    placeholder="e.g., ₹10,00,000"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-switch
                                    v-model="formData.is_active"
                                    label="Is Active"
                                    color="primary_2"
                                    inset
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-switch
                                    v-model="formData.flag_recomended"
                                    label="Recommended Product"
                                    color="success"
                                    inset
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-switch
                                    v-model="formData.enable_manual_application"
                                    label="Manual Application"
                                    color="orange"
                                    inset
                                ></v-switch>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="error" @click="closeDialog">Cancel</v-btn>
                    <v-btn color="success" @click="submitForm" :disabled="!valid || isSubmitting" :loading="isSubmitting">
                        Edit Details
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>


export default {
    data()  {
        return {
            showDialog: false,
            valid: false,
            isSubmitting: false,
            productId: null,
            originalRank: null,
            productTypes: [],
            rankRules: [
                (v) => v === "" || v == null || /^[1-9]\d*$/.test(String(v)) || "Whole number, 1 or more",
            ],
            requiredArrayRule: [
                (value) =>
                    (Array.isArray(value) && value.length > 0) || "This field is required",
            ],
            formData: this.getEmptyFormData(),
        }
    },
    mounted() {
        this.getProductTypes();  
    },
    methods: {
        getEmptyFormData() {
            return {
                name: "",
                title: "",
                rank: "",
                web_url: "",
                utm_link: "",
                product_type_ids: [],
                interest_rate: "",
                tenure: "",
                loan_upto: "",
                is_active: true,
                flag_recomended: false,
                enable_manual_application: false,
            };
        },
        openDialog(item) {
            this.productId = item.id;
            // Remembered so an untouched Rank box is not re-sent: another admin
            // may have moved the product since this list was loaded.
            this.originalRank = item.rank ?? null;
            this.formData = {
                name: item.name || "",
                title: item.title || "",
                rank: item.rank ?? "",
                web_url: item.web_url || "",
                utm_link: item.utm_link || "",
                product_type_ids: item.product_type ? [item.product_type.id] : [],
                interest_rate: item.interest_rate || "",
                tenure: item.tenure || "",
                loan_upto: item.loan_upto || "",
                is_active: Boolean(item.is_active),
                flag_recomended: Boolean(item.flag_recomended),
                enable_manual_application: Boolean(item.enable_manual_application),
            };
            this.showDialog = true;
            this.$nextTick(() => {
                if (this.$refs.productForm) {
                    this.$refs.productForm.resetValidation();
                }
            });
        },
        closeDialog() {
            this.showDialog = false;
            this.resetForm();
        },
        getProductTypes() {
            const self = this;

            const params = { flag_active: false };

            const successHandler = (response) => {
                self.productTypes = response.data.result;
            };

            self.request_GET(
                self,
                self.$urls.GET_LOAN_TYPE,
                params,
                successHandler,
                null,
                null
            );
        },
        resetForm() {
            this.productId = null;
            this.formData = this.getEmptyFormData();
            if (this.$refs.productForm) {
                this.$refs.productForm.resetValidation();
            }
        },
        submitForm() {
            const self = this;
            if (!this.$refs.productForm.validate() || !this.productId) {
                return;
            }

            const formData = {
                name: this.formData.name,
                title: this.formData.title,
                web_url: this.formData.web_url,
                utm_link: this.formData.utm_link,
                product_type_ids: this.formData.product_type_ids,
                interest_rate: this.formData.interest_rate,
                tenure: this.formData.tenure,
                loan_upto: this.formData.loan_upto,
                is_active: this.formData.is_active,
                flag_recomended: this.formData.flag_recomended,
                enable_manual_application: this.formData.enable_manual_application,
            };
            // A position (1 = shown first), not the raw priority, where a bigger
            // number sorts higher. Only sent when the admin changed it.
            const rank = parseInt(this.formData.rank, 10);
            if (rank > 0 && rank !== this.originalRank) {
                formData.rank = rank;
            }

            self.isSubmitting = true;

            const successHandler = () => {
                self.showSnakeBar("success", "Product updated successfully");
                self.closeDialog();
                self.$emit("updated");
            };

            const errorHandler = (error) => {
                const message =
                    self.getApiErrorMessage(error) || "Failed to update product";
                self.showSnakeBar("error", message);
            };

            const finallyHandler = () => {
                self.isSubmitting = false;
            };

            self.request_PATCH(
                self,
                self.$urls.UPDATE_ADMIN_PRODUCT_DATA,
                `${this.productId}/`,
                formData,
                successHandler,
                null,
                errorHandler,
                finallyHandler
            );
        }
    }
}
</script>
